/**
 * Ambient motes — tiny particles drifting upward from the void edge.
 */

import type { Graphics } from 'pixi.js';
import { VOID } from '../../constants';
import type { VoidState } from './types';
import { visibleX, lerp } from './types';

export function updateAmbientMotes(gfx: Graphics, dt: number, voidY: number, state: VoidState): void {
  const ambientMax = state.riseIntensity > 0.1
    ? lerp(VOID.AMBIENT_MAX, VOID.AMBIENT_MAX_RISE, state.riseIntensity)
    : VOID.AMBIENT_MAX;
  const ambientSpawn = state.riseIntensity > 0.1
    ? lerp(VOID.AMBIENT_SPAWN_RATE, VOID.AMBIENT_SPAWN_RISE, state.riseIntensity)
    : VOID.AMBIENT_SPAWN_RATE;

  if (state.ambientMotes.length < ambientMax && Math.random() < ambientSpawn) {
    const av = visibleX();
    state.ambientMotes.push({
      x: av.off + Math.random() * av.w,
      y: voidY - Math.random() * 5,
      vx: (Math.random() - 0.5) * 15,
      vy: -(10 + Math.random() * 20),
      life: 1.0 + Math.random() * 1.5,
      maxLife: 1.0 + Math.random() * 1.5,
      radius: 1 + Math.random() * 2,
      color: Math.random() < 0.6 ? VOID.EDGE_COLOR : 0x8800ff,
    });
  }

  gfx.clear();
  for (let i = state.ambientMotes.length - 1; i >= 0; i--) {
    const m = state.ambientMotes[i];
    m.life -= dt;
    if (m.life <= 0) {
      state.ambientMotes.splice(i, 1);
      continue;
    }
    m.x += m.vx * dt;
    m.y += m.vy * dt;

    const mt = m.life / m.maxLife;
    gfx.circle(m.x, m.y, m.radius);
    gfx.fill({ color: m.color, alpha: mt * 0.6 });
  }
}
